import React, { useState } from "react";
import { useMediaQuery, Box } from "@mui/material";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

function ResponsiveDateRangePicker({ blockedDates, value, onChange }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [selectedRange, setSelectedRange] = useState({
    startDate: value[0],
    endDate: value[1],
    key: "selection",
  });

  const handleSelect = (ranges) => {
    const { selection } = ranges;
    setSelectedRange(selection);
    onChange([selection.startDate, selection.endDate]);
  };

  const isDateBlocked = (date) => {
    return blockedDates.some((blockedDate) => {
      const start = dayjs(blockedDate.start);
      const end = dayjs(blockedDate.end);
      return dayjs(date).isBetween(start, end, null, "[]");
    });
  };

  const definedRanges = [
    {
      ...selectedRange,
      disabledDates: blockedDates.flatMap(({ start, end }) =>
        Array.from(
          { length: dayjs(end).diff(dayjs(start), "day") + 1 },
          (_, i) => dayjs(start).add(i, "day").toDate(),
        ),
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        ".rdrDayDisabled": {
          backgroundColor: "rgba(255, 0, 0, 0.1) !important",
        },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <DateRange
        ranges={definedRanges}
        onChange={handleSelect}
        months={isMobile ? 1 : 2}
        direction={isMobile ? "vertical" : "horizontal"}
        disabledDates={definedRanges[0].disabledDates}
        showSelectionPrevie={"false"}
      />
    </Box>
  );
}

export default ResponsiveDateRangePicker;
